import { inject, Pipe, PipeTransform } from '@angular/core';
import { AdminType } from '../enums/admin-type.enum';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'adminTypeTitle'
})
export class AdminTypeTitlePipe implements PipeTransform {
  translocoService = inject(TranslocoService);
  transform(adminType: AdminType): unknown {
    if (!adminType) {
      return '';
    }

    switch (adminType) {
      case AdminType.admin:
        return this.translocoService.translate('admin.admin_type.admin.title');
      case AdminType.patientManager:
        return this.translocoService.translate('admin.admin_type.patient_manager.title');
      case AdminType.none:
        return this.translocoService.translate('admin.admin_type.none.title');
    }
  }
}
